export const getBookingsBaseUrl = (accountKind?: string): string => {
  if (accountKind === 'SITTER') {
    return '/provider/bookings';
  }
  return '/bookings';
};

export const getBookingsUrlWithNotification = (notification: string, accountKind?: string): string => {
  const baseUrl = getBookingsBaseUrl(accountKind);
  return `${baseUrl}?notification=${encodeURIComponent(notification)}`;
};

export const getContractUrl = (nodeId: string, accountKind?: string): string => {
  const baseUrl = getBookingsBaseUrl(accountKind);
  return `${baseUrl}/${nodeId}`;
};

export const getRequestUrl = (nodeId: string): string => {
  return `/requests/${nodeId}`;
};

export const getSitterJobsURL = (providerType: string): string => {
  const jobsURL = '/jobs/search';

  switch (providerType) {
    case 'BABYSITTER':
      return `${jobsURL}?search_strategy=babysitter_job`;
    case 'NANNY':
      return `${jobsURL}?search_strategy=nanny_job`;
    case 'SPECIAL_NEEDS':
      return `${jobsURL}?search_strategy=special_needs_job`;
    case 'COMPANION_CARE':
      return `${jobsURL}?search_strategy=companion_care_job`;
    case 'PET_CARE':
      return `${jobsURL}?search_strategy=pet_care_job`;
    case 'HOUSEKEEPING':
      return `${jobsURL}?search_strategy=housekeeping_job`;
    default:
      return jobsURL;
  }
};

export const getParentJobsURL = (careType: string, zipcode: string): string => {
  const newSearchURL = '/availability/search';
  const oldSearchURL = '/profile/provider/search?search_strategy=';
  const zipcodeParam = zipcode ? `&zipcode=${zipcode}` : '';

  switch (careType) {
    case 'BABYSITTER':
      return `${newSearchURL}?careType=babysitter${zipcodeParam}`;
    case 'NANNY':
      return `${newSearchURL}?careType=nanny${zipcodeParam}`;
    case 'SPECIAL_NEEDS':
      return `${oldSearchURL}special_needs${zipcodeParam}`;
    case 'COMPANION_CARE':
      return `${oldSearchURL}companion_care${zipcodeParam}`;
    case 'PET_CARE':
      return `${oldSearchURL}pet_care${zipcodeParam}`;
    case 'HOUSEKEEPING':
      return `${oldSearchURL}housekeeping${zipcodeParam}`;
    default:
      return newSearchURL;
  }
};
